"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const salefilled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-salefilled` : '') + (description ? ` desc-salefilled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-salefilled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-salefilled"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.56886V1.65678C0 1.21737 0.174553 0.795966 0.485259 0.485259C0.795966 0.174553 1.21737 0 1.65678 0H8.56886C9.4476 0.000187671 10.2903 0.349417 10.9115 0.970873L23.7571 13.8164C23.8632 13.9224 23.9385 14.0552 23.9751 14.2007C24.0116 14.3461 24.0079 14.4988 23.9645 14.6423C23.9211 14.7859 23.8395 14.9149 23.7285 15.0157C23.6174 15.1166 23.4811 15.1853 23.3341 15.2148L16.5678 16.5678L15.2148 23.3341C15.1853 23.4811 15.1166 23.6174 15.0157 23.7285C14.9149 23.8395 14.7859 23.9211 14.6423 23.9645C14.4988 24.0079 14.3461 24.0116 14.2007 23.9751C14.0552 23.9385 13.9224 23.8632 13.8164 23.7571L0.970872 10.9115C0.349417 10.2903 0.000187671 9.4476 0 8.56886ZM4.6271 6.97024C4.3164 6.65954 4.14185 6.23813 4.14185 5.79872C4.14185 5.35932 4.3164 4.93791 4.6271 4.6272C4.93781 4.3165 5.35922 4.14194 5.79862 4.14194C6.23803 4.14194 6.65944 4.3165 6.97014 4.6272C7.28085 4.93791 7.4554 5.35932 7.4554 5.79872C7.4554 6.23813 7.28085 6.65954 6.97014 6.97024C6.65944 7.28095 6.23803 7.4555 5.79862 7.4555C5.35922 7.4555 4.93781 7.28095 4.6271 6.97024Z",
    fill: "black"
  }));
};
var _default = exports.default = salefilled;